<template>
  <div>
    <van-nav-bar
      class="backBox"
      :title="h5Config.textCfg.roomName + '预约'"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="content_box">
      <div class="top-bg" />
      <div class="full-title-parent">
        <div class="appoint-date-wrap">
          <div
            @click="preDay"
            :style="{ color: enablePreDay ? 'white' : '#ccc' }"
          >
            前一天
          </div>
          <div class="full-date" @click="openTimePopup">
            {{ seltDateShow }}
          </div>

          <van-popup v-model="showPopup" position="bottom">
            <van-datetime-picker
              v-model="currentDate"
              type="date"
              title="选择年月日"
              :min-date="minDate"
              :max-date="maxDate"
              @confirm="timePickerConfirm"
              @cancel="timePickerCancel"
              @change="bindDateChange"
            >
            </van-datetime-picker>
          </van-popup>
          <!-- <picker
                mode="date"
                value="{{bindSelectDate}}"
                start="{{appointStartDate}}"
                end="{{appointEndDate}}"
                bindchange="bindDateChange"
              >
              </picker> -->
          <div
            @click="nextDay"
            :style="{ color: enableNextDay ? 'white' : '#ccc' }"
          >
            后一天
          </div>
        </div>
        <div class="building-info">
          <div class="building">{{ buildingNo }}</div>
          <div class="building-floor">
            {{ roomNumber }}
          </div>
          <div class="building-room-type">
            {{ typeName }}
          </div>
        </div>
      </div>
      <div class="selected-time-wrap">
        <div
          class="show-start-time"
          :class="seltStartTime ? '' : 'empty'"
          @click="hintClickTime"
        >
          {{ seltStartTime ? seltStartTime.startTime : '开始时间' }}
        </div>
        <span>至</span>
        <div
          class="show-end-time"
          :class="seltEndTime ? '' : 'empty'"
          @click="hintClickTime"
        >
          {{ seltEndTime ? seltEndTime.endTime : '结束时间' }}
        </div>
      </div>

      <div class="content-parent">
        <div class="time-list-parent">
          <!--             :class="index === startTimeIndex ? 'start' : '' (index > startTimeIndex && index < endTimeIndex) ? 'include' : '' index == endTimeIndex ? 'end' : '' item.overdueCur ? 'invalid' : '' (index == startTimeIndex && index == endTimeIndex) ? 'only' : '' item.overdueCur ? 'line-through' : ''"
 -->
          <div
            v-for="(item, index) in timeQuantumList"
            :key="item.id"
            class="time-list-item"
            :class="[
              'time-list-item',
              index === startTimeIndex ? 'start' : '',
              index > startTimeIndex && index < endTimeIndex ? 'include' : '',
              index == endTimeIndex ? 'end' : '',
              item.overdueCur ? 'invalid' : '',
              index == startTimeIndex && index == endTimeIndex ? 'only' : '',
              item.overdueCur ? 'line-through' : '',
            ]"
            @click="seltTime(item, index)"
            :style="{
              visibility: item.fill_element ? 'hidden' : 'visible',
            }"
          >
            <div class="time-list-item-content">{{ item.showTime }}</div>
          </div>
          <div style="height: 80rpx; width: 100%"></div>
        </div>
      </div>
      <div class="bottom-shade"></div>
      <div class="appointment" @click="doSubmit">立即预约</div>
      <!-- 多人琴房选择人数 -->
      <van-dialog v-model="showOrderMoreUser" title="多人房间" show-cancel-button @confirm="confirmMoreUser">
        <div class="orderUserBox">
<!--          <div class="title"><i style="color:#74B0F9" class="iconfont icon-lingdang"></i>此房间可允许多人使用，请选择您的使用人数</div>-->
<!--          <div class="number">-->
<!--            <div>预约人数</div>-->
<!--            <van-field v-model="orderNumber" type="number" placeholder="请输入人数" input-align="center" label="" />-->
<!--            人-->
<!--          </div>-->
          <van-field
              readonly
              clickable
              :value="orderPurpose"
              label="用途"
              placeholder="点击选择用途"
              @click="showOrderPurposePicker = true">
          </van-field>
          <van-field
              v-model="orderNumber"
              label-width="7.2em"
              type="number"
              maxlength="3"
              label="使用人数"
              placeholder="请输入">
          </van-field>
        </div>
      </van-dialog>
      <van-popup v-model="showOrderPurposePicker" position="bottom">
        <van-picker
            show-toolbar
            :columns="orderPurposeOption"
            @confirm="onConfirmOrderPurpose"
            @cancel="showOrderPurposePicker = false"/>
      </van-popup>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'
import * as common from '../../api/common'
import * as utils from '../../api/utils'
import * as constant from '../../api/constant'
import { Toast, Dialog } from 'vant'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      options: {},
      minDate: new Date(),
      maxDate: new Date(),
      showPopup: false,
      currentDate: '',
      roomId: '',
      typeName: '',
      roomNumber: '',
      buildingNo: '',
      appointStartDate: '',
      appointEndDate: '',
      bindSelectDate: '',
      seltDate: '',
      seltDateShow: '',
      startTimeIndex: -1,
      endTimeIndex: -1,
      seltStartTime: null,
      seltEndTime: null,
      timeQuantumList: [],
      capacity: 0, // 获取所有预约时会返
      enablePreDay: false,
      enableNextDay: false,
      configData: {},
      showOrderMoreUser: false,
      showOrderPurposePicker: false,
      orderPurposeOption: [
        '实习见习试讲',
        '上课（教师）',
        '完成作业',
        '竞赛训练',
        '日常技能训练',
        '教资面试训练',
        '教师招聘面试训练',
        '其他'
      ],
      orderPurpose: null,
      orderNumber: 1,
      agreeOrderUser: ''
    }
  },
  mounted () {
    const options = this.$route.query
    this.options = options
    console.log('接受参数', this.options)
    const configData = api.getConfig(common.keyConfigInfo)
    if (configData) {
      this.configData = configData
    }
    this.getToday()
    this.getLimitDate()
  },
  computed: {
    ...mapGetters([
      'h5Config'
    ]),
    ...mapGetters([
      'userInfo'
    ]),
    userInfoJSONParse () {
      return JSON.parse(this.userInfo) ? JSON.parse(this.userInfo) : null
    }
  },
  methods: {
    onConfirmOrderPurpose (value) {
      this.orderPurpose = value
      this.showOrderPurposePicker = false
    },
    confirmMoreUser () {
      if (!this.orderPurpose || !this.orderPurpose.trim()) {
        Dialog.alert({
          title: '提示',
          message: '用途不能为空',
          confirmButtonText: '重新输入'
        }).then(() => {
          this.showOrderMoreUser = true
        })
      } else if (Number(this.orderNumber) < 1 || Number(this.orderNumber > 100)) {
        Dialog.alert({
          title: '提示',
          message: '预约人数为1-100以内',
          confirmButtonText: '重新输入'
        }).then(() => {
          this.showOrderMoreUser = true
        })
      } else {
        this.submitAppointment()
      }
    },
    getLimitDate () {
      const currentDate = utils.formatTimeYMDInterval(new Date(), '-')
      this.minDate = new Date(currentDate)

      const configData = JSON.parse(localStorage.getItem(common.keyConfigInfo))

      let aheadLimit = 0
      this.configInfo = configData

      if (configData) {
        aheadLimit = this.configInfo.ahead_limit
      }
      if (aheadLimit > 0) {
        const seltDateShow = this.seltDate

        const curTime = new Date()

        const appointEndDate = utils.formatTimeYMDInterval(new Date(new Date().setDate(curTime.getDate() + aheadLimit - 1)), '-')
        const difValue = this.dayDifValue(seltDateShow, curTime)
        if (difValue < 0 || difValue > (aheadLimit - 1)) {
          if (this.buildingData.length) {
            const bdData = this.buildingData[0]

            this.selDateText = utils.formatTimeYMDChinese(curTime)
            this.seltDateShow = utils.formatTimeYMDInterval(curTime, '-')

            this.selBuildingData = bdData
            this.selLayerData = bdData.layerData[0]
            this.layerModel = 1
            this.selRoomData = null
            this.maxDate = new Date(appointEndDate)
          } else {
            this.selDateText = utils.formatTimeYMDChinese(curTime)
            this.seltDateShow = utils.formatTimeYMDInterval(curTime, '-')

            this.layerModel = 1
            this.selRoomData = null
            this.maxDate = new Date(appointEndDate)
          }
          this.getLayerRoom()
        } else {
          this.maxDate = new Date(appointEndDate)
        }
      } else {

      }
    },
    seltTime (item, index) {
      if (item.overdueCur) {
        Toast('该时间段不可用')
      } else if (this.seltStartTime) {
        if (item.notConnectCur) {
          this.seltStartTime = item
          this.startTimeIndex = index
          this.seltEndTime = item
          this.endTimeIndex = index
        } else if (index === this.startTimeIndex && index === this.endTimeIndex) {
          this.seltStartTime = null
          this.startTimeIndex = -1
          this.seltEndTime = null
          this.endTimeIndex = -1
        } else if (this.startTimeIndex !== this.endTimeIndex) {
          this.seltStartTime = item
          this.startTimeIndex = index
          this.seltEndTime = item
          this.endTimeIndex = index
        } else if (index < this.startTimeIndex) {
          this.seltStartTime = item
          this.startTimeIndex = index
        } else {
          this.seltEndTime = item
          this.endTimeIndex = index
        }
        this.refreshOverdueCur()
      } else {
        this.seltStartTime = item
        this.startTimeIndex = index
        this.seltEndTime = item
        this.endTimeIndex = index

        this.refreshOverdueCur()
      }
    },
    openTimePopup () {
      this.showPopup = true
    },
    doSubmit () {
      if (!this.seltStartTime || !this.seltEndTime) {
        Toast.fail('请选择预约时间')
        return false
      }

      const h5Config = this.$store.state.h5Config.h5Config
      if (h5Config && h5Config.funCfg.showH5Capacity) {
        this.showOrderMoreUser = true
        return
      }
      this.submitAppointment()
    },
    submitAppointment () {
      const that = this
      if (!this.seltStartTime || !this.seltEndTime) {
        return Toast.fail('请选择预约时间')
      }
      let startTimeStr = this.seltStartTime.startTime
      let startTotalMinutes = this.seltStartTime.startTotalMinutes
      const now = new Date()
      const difValue = that.dayDifValue(that.seltDate, now)
      if (difValue <= 0) {
        const nowHours = now.getHours()
        const nowMinutes = now.getMinutes()
        if (this.seltStartTime.startTotalMinutes < nowHours * 60 + nowMinutes) {
          const nowTotalMinutes = nowHours * 60 + nowMinutes
          startTotalMinutes = Math.ceil(nowTotalMinutes / 5) * 5
          const hourStr = '00' + Math.floor(startTotalMinutes / 60)
          const minuteStr = '00' + Math.floor(startTotalMinutes % 60)
          startTimeStr = hourStr.substring(hourStr.length - 2) + ':' + minuteStr.substring(minuteStr.length - 2)
        }
        // if (this.seltEndTime.startTotalMinutes < startTotalMinutes) {
        //   return Toast.fail('请重新选择预约时间')
        // }
      }
      Toast.loading({
        message: '预约中...',
        forbidClick: true
      })
      const seltDateStr = utils.formatTimeYMDInterval(that.seltDate, '-')
      const para = {
        room_id: that.roomId,
        book_date: seltDateStr,
        begin_time: seltDateStr + ' ' + startTimeStr + ':00',
        end_time: seltDateStr + ' ' + that.seltEndTime.endTime + ':00',
        support_time_rule: that.h5Config.funCfg.openRoomTimeRule,
        book_numbers: Number(this.orderNumber)
      }
      if (this.orderPurpose) {
        para.info = {
          purpose: this.orderPurpose || null
        }
      }
      api
        .axiosRequest(api.urlList.appointmentPiano, para)
        .then((res) => {
          let showType = 1
          let errorMsg
          if (res.code === common.resCode.OK) {
            if (!errorMsg) {
              errorMsg = ''
            }
            const seltTime = utils.formatTimeMDChinese(that.seltDate) + ' ' + startTimeStr + '-' + that.seltEndTime.endTime
            Toast.clear()
            that.$router.replace({
              path: '/orderResult',
              query: {
                showType: showType,
                subscribe: ((res.subscribe && res.subscribe !== 0) ? 1 : 0),
                errorMsg: errorMsg,
                typeName: that.typeName,
                roomNumber: that.roomNumber,
                buildingNo: that.buildingNo,
                seltTime: seltTime
              }
            })
          } else {
            if (res.code === 11118) {
              errorMsg = res.msg || errorMsg
              showType = 3 // 余额不足
              Toast.fail(errorMsg)
            } else {
              utils.judgeBackMsg(res)
              that.getPianoOneDayReserved()
            }
            return false
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    hintClickTime () {

    },
    preDay () {
      if (!this.enablePreDay) {
        return false
      }
      try {
        const dateTime = new Date(this.seltDate)
        dateTime.setDate(dateTime.getDate() - 1)
        this.setFilterDateTime(dateTime)
        const { pre, next, appointStartDate, appointEndDate } = this.getPreDayNextDayDisable(dateTime)

        this.enablePreDay = pre
        this.enableNextDay = next
        this.appointStartDate = appointStartDate
        this.appointEndDate = appointEndDate
        this.seltDate = dateTime
        this.bindSelectDate = utils.formatTimeYMDInterval(dateTime)
        this.seltDateShow = this.getShowDate(dateTime)

        this.getPianoOneDayReserved()
      } catch (e) {
        console.log(e)
      }
    },
    nextDay () {
      if (!this.enableNextDay) {
        return false
      }
      const dateTime = new Date(this.seltDate)
      dateTime.setDate(dateTime.getDate() + 1)
      const selDate = new Date(dateTime)
      this.setFilterDateTime(selDate)
      this.getPianoOneDayReserved()
    },
    getToday () {
      let seltDate = decodeURIComponent(this.options.selDate)

      seltDate = utils.formatDate(seltDate)
      const { pre, next, appointStartDate, appointEndDate } = this.getPreDayNextDayDisable(seltDate)

      this.roomId = this.options.roomId
      this.typeName = this.options.typeName
      this.roomNumber = this.options.roomName
      this.buildingNo = this.options.buildingNo
      this.seltDate = seltDate
      this.seltDateShow = this.getShowDate(seltDate)
      this.bindSelectDate = utils.formatTimeYMDInterval(seltDate)
      this.enablePreDay = pre
      this.enableNextDay = next
      this.appointStartDate = appointStartDate
      this.appointEndDate = appointEndDate

      this.getPianoOneDayReserved()
    },
    clearTime () {
      this.seltStartTime = null
      this.startTimeIndex = -1
      this.seltEndTime = null
      this.endTimeIndex = -1

      this.refreshOverdueCur()
    },
    refreshOverdueCur () {
      const index = this.startTimeIndex
      const timeQuantumList = this.timeQuantumList
      if (index >= 0) {
        timeQuantumList[index].notConnectCur = false
        for (let c = index + 1; c < timeQuantumList.length; ++c) {
          timeQuantumList[c].notConnectCur = timeQuantumList[c].overdueCur || timeQuantumList[c - 1].notConnectCur
        }
        for (let b = index - 1; b >= 0; --b) {
          timeQuantumList[b].notConnectCur = timeQuantumList[b].overdueCur || timeQuantumList[b + 1].notConnectCur
        }
      } else {
        for (let d = 0; d < timeQuantumList.length; ++d) {
          timeQuantumList[d].notConnectCur = false
        }
      }
      this.timeQuantumList = timeQuantumList
    },
    getPianoOneDayReserved () {
      const that = this

      this.clearTime()

      const hintMd = utils.formatTimeMDChinese(that.seltDate)
      const para = {
        room_id: that.roomId,
        book_date: utils.formatTimeYMDInterval(that.seltDate, '-'),
        support_time_rule: that.h5Config.funCfg.openRoomTimeRule
      }
      api
        .axiosRequest(api.urlList.getPianoOneDayReserved, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            const appointmentList = []
            const curTime = new Date()
            const difValue = that.dayDifValue(that.seltDate, curTime)
            const week = that.seltDate.getDay()
            const allconfigs = utils.refreshConfigData(week)
            const forbiddenRooms = res.forbidden_rooms || []
            api.setConfig(JSON.stringify(allconfigs))
            this.capacity = res.capacity
            this.configData = allconfigs
            let end
            if (difValue === 0) {
              // 此处为计算当前时间段与当天已过时间段
              const span = (this.configInfo && this.configInfo.base_span) || 30
              end = Math.floor((curTime.getHours() * 60 + curTime.getMinutes()) / span) * span
              // 添加上当前已经过去的时间段
              appointmentList.push({
                startTotalMinutes: 0,
                isExpire: true,
                // endTotalMinutes: curTime.getHours() * 60 + curTime.getMinutes() + 1
                endTotalMinutes: end
              })
            }
            try {
              const isForbidden = forbiddenRooms.find(function (o) {
                return parseInt(o.room_id) === parseInt(that.roomId)
              })
              if (isForbidden && Array.isArray(isForbidden.time_list)) {
                for (let i = 0; i < isForbidden.time_list.length; i++) {
                  if (isForbidden.time_list[i].week_days.includes(week)) {
                    const startSplit = isForbidden.time_list[i].start_time.split(':')
                    const endSplit = isForbidden.time_list[i].end_time.split(':')
                    appointmentList.push({
                      startTotalMinutes: parseInt(startSplit[0]) * 60 + parseInt(startSplit[1]),
                      isExpire: true,
                      endTotalMinutes: parseInt(endSplit[0]) * 60 + parseInt(endSplit[1])
                    })
                  }
                }
              }
            } catch (e) {
              console.log(e)
            }

            const notAllowTimeList = that.getNotAllowTimeList(res.room_rule_list)
            if (Array.isArray(notAllowTimeList) && notAllowTimeList.length) {
              notAllowTimeList.forEach(item => {
                appointmentList.push({
                  startTotalMinutes: item.startMinutes,
                  isExpire: true,
                  endTotalMinutes: item.endMinutes
                })
              })
            }

            let userId
            try {
              if (this.userInfoJSONParse) {
                userId = Number(this.userInfoJSONParse.userid)
              }
            } catch (e) {
              console.log(e)
            }
            for (let f = 0; f < res.list.length; ++f) {
              const c = res.list[f]

              const start = utils.formatDate(c.begin_time)
              const end = utils.formatDate(c.end_time)
              let isExpire = false
              if (c.status === 11) { // 课程
                isExpire = true
              } else if (c.status === 12) {
                isExpire = true
              } else if (c.user_id === userId) {
                isExpire = true
              }
              appointmentList.push({
                startTotalMinutes: start.getHours() * 60 + start.getMinutes(),
                endTotalMinutes: end.getHours() * 60 + end.getMinutes(),
                isExpire: isExpire
              })
            }
            const timeQuantumList = that.getTimeQuantumList(appointmentList, res.time_rule_info, end)
            if (timeQuantumList.length === 0) {
              Toast.fail(hintMd + '没有开放的预约时间')
            }
            // 用来填充布局
            let fillNum = (3 - timeQuantumList.length % 3) % 3
            while (fillNum > 0) {
              --fillNum
              timeQuantumList.push({
                fill_element: true
              })
            }
            this.timeQuantumList = timeQuantumList
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    getNotAllowTimeList (list) {
      const result = []
      if (Array.isArray(list) && list.length) {
        list.forEach(item => {
          const start = item.start_time.split(':')
          const end = item.end_time.split(':')
          item.startMinutes = parseInt(start[0]) * 60 + parseInt(start[1])
          item.endMinutes = parseInt(end[0]) * 60 + parseInt(end[1])
        })
        list.sort(function (a, b) {
          if (a.startMinutes === b.startMinutes) {
            return a.endMinutes - b.endMinutes
          }
          return a.startMinutes - b.startMinutes
        })
        let temp = 0
        do {
          const o = list.shift()
          const obj = {
            start: temp,
            end: o.startMinutes
          }
          if (temp < o.startMinutes) {
            let appointEnd = o.endMinutes
            for (let i = 0; i < list.length; i++) {
              if (list[i].startMinutes < o.endMinutes) {
                appointEnd = list[i].endMinutes
              }
            }
            temp = appointEnd
            result.push({
              startMinutes: obj.start,
              isExpire: true,
              endMinutes: obj.end
            })
          } else {
            temp = o.endMinutes
          }
        } while (list.length)
        if (temp < 1440) {
          result.push({
            startMinutes: temp,
            isExpire: true,
            endMinutes: 1440
          })
        }
      }
      if (result.length) {
        return result
      }
    },
    getTimeQuantumList (appointmentList, timeRuleInfo, isToday) {
      let timeQuantumList = []
      if (this.h5Config.funCfg.openRoomTimeRule) {
        if (timeRuleInfo) {
          timeQuantumList = utils.getTimeQuantum(timeRuleInfo.quantum, timeRuleInfo.book_interval)
        }
      } else {
        const configStartTime = this.configData.begin_time
        const configEndTime = this.configData.end_time

        const start = configStartTime.split(':')
        const startHour = parseInt(start[0])
        const startMinutes = parseInt(start[1])
        const startTotalMinutes = startHour * 60 + startMinutes

        const end = configEndTime.split(':')
        const endHour = parseInt(end[0])
        const endMinutes = parseInt(end[1])
        const endTotalMinutes = endHour * 60 + endMinutes

        // 每段时间长度 分钟
        const eachLength = (this.configData && this.configData.base_span) || 30
        // 整个总时长
        const totalTime = endTotalMinutes - startTotalMinutes
        // 去除多余的时间，计算整个总时长可分成的段数
        const timeQuantumNum = (totalTime - totalTime % eachLength) / eachLength
        // 取段落从零开始计数
        let count = 0
        while (count < timeQuantumNum) {
          // 时间段开始时间
          const nodeStartTotalMinutes = startTotalMinutes + (count * eachLength)
          let nodeStartMinutes = nodeStartTotalMinutes % 60
          let nodeStartHour = (nodeStartTotalMinutes - nodeStartMinutes) / 60
          nodeStartMinutes = this.formatNumber(nodeStartMinutes)
          nodeStartHour = this.formatNumber(nodeStartHour)
          // 时间段结束时间
          const nodeEndTotalMinutes = nodeStartTotalMinutes + eachLength
          let nodeEndMinutes = nodeEndTotalMinutes % 60
          let nodeEndHour = (nodeEndTotalMinutes - nodeEndMinutes) / 60
          nodeEndMinutes = this.formatNumber(nodeEndMinutes)
          nodeEndHour = this.formatNumber(nodeEndHour)

          timeQuantumList.push({
            showTime: nodeStartHour + ':' + nodeStartMinutes + '-' + nodeEndHour + ':' + nodeEndMinutes,
            startTime: nodeStartHour + ':' + nodeStartMinutes,
            endTime: nodeEndHour + ':' + nodeEndMinutes,
            startTotalMinutes: nodeStartTotalMinutes,
            endTotalMinutes: nodeEndTotalMinutes,
            overdueCur: false, // 是否被占用 当使用和容量相等时为true或者已过期
            continuousCur: false, // 相对于被选中的时间段是否是可选的
            bookTotal: 0 // 预约的次数
          })
          ++count
        }
      }
      const newStartTime = new Date()
      let startHours = newStartTime.getHours()
      let startMinutes = newStartTime.getMinutes()
      const minutesSpan = Math.ceil(startMinutes / 5)
      if (minutesSpan === 12) {
        startMinutes = 0
        startHours++
      } else {
        startMinutes = minutesSpan * 5
      }
      const newStartMinutesTotal = startHours * 60 + startMinutes
      for (let c = 0; c < timeQuantumList.length; ++c) {
        const timeQuantum = timeQuantumList[c]
        for (let f = 0; f < appointmentList.length; ++f) {
          const g = appointmentList[f]
          if (g.startTotalMinutes < timeQuantum.endTotalMinutes &&
              g.endTotalMinutes > timeQuantum.startTotalMinutes) {
            if (g.isExpire) {
              if (isToday && timeQuantum.endTotalMinutes > newStartMinutesTotal && timeQuantum.startTotalMinutes < newStartMinutesTotal) {
                if (g.endTotalMinutes > newStartMinutesTotal) {
                  timeQuantum.bookTotal++
                }
                if (timeQuantum.bookTotal >= this.capacity) {
                  timeQuantum.overdueCur = true
                } else {
                  const hStr = '00' + startHours
                  const mStr = '00' + startMinutes
                  timeQuantum.startTotalMinutes = newStartMinutesTotal
                  timeQuantum.startTime = `${hStr.substring(hStr.length - 2)}:${mStr.substring(mStr.length - 2)}`
                  timeQuantum.showTime = `${timeQuantum.startTime}-${timeQuantum.endTime}`
                }
              } else {
                timeQuantum.overdueCur = true
              }
            } else {
              timeQuantum.bookTotal++
              if (timeQuantum.bookTotal >= this.capacity) {
                timeQuantum.overdueCur = true
              }
            }
          }
        }
      }
      return timeQuantumList
    },
    formatNumber (n) {
      n = n.toString()
      return n[1] ? n : '0' + n
    },
    dayDifValue (date1, date2) {
      const oneDayMillisecond = 1000 * 60 * 60 * 24
      const str1 = utils.formatTimeYMDInterval(date1, '-') + ' 00:00:00'
      const str2 = utils.formatTimeYMDInterval(date2, '-') + ' 00:00:00'

      const new1 = utils.formatDate(str1)
      const new2 = utils.formatDate(str2)

      const diff = new1.getTime() - new2.getTime()
      return (diff - diff % oneDayMillisecond) / oneDayMillisecond
    },
    bindDateChange () {

    },
    timePickerConfirm () {
      this.setFilterDateTime(this.currentDate)
      this.getPianoOneDayReserved()
      this.showPopup = false
    },
    timePickerCancel () {
      this.showPopup = false
    },
    setFilterDateTime (dateTime) {
      const { pre, next, appointStartDate, appointEndDate } = this.getPreDayNextDayDisable(dateTime)

      this.enablePreDay = pre
      this.enableNextDay = next
      this.appointStartDate = appointStartDate
      this.appointEndDate = appointEndDate
      this.seltDate = dateTime
      this.bindSelectDate = utils.formatTimeYMDInterval(dateTime)
      this.seltDateShow = this.getShowDate(dateTime)
    },
    onClickLeft () {
      this.$router.go(-1)
      // this.$router.back(-1)
    },
    getShowDate (seltDate) {
      let showDate
      const today = new Date()
      if (typeof seltDate === 'string') {
        if (utils.judgeClient() !== constant.judgeClientType.Android) {
          showDate = new Date(seltDate)
        } else {
          showDate = new Date(seltDate.replace(/-/g, '/'))
        }
      } else {
        showDate = seltDate
      }
      if (showDate.getFullYear() === today.getFullYear() &&
        showDate.getMonth() === today.getMonth() &&
        showDate.getDay() === today.getDay()) {
        return utils.formatTimeMDChinese(showDate) + ' 今日'
      } else {
        return utils.formatTimeMDChinese(showDate)
      }
    },
    getPreDayNextDayDisable (seltDate) {
      const selDate = new Date(seltDate)
      const now = new Date()
      const appointStartDate = utils.formatTimeYMDInterval(now, '-')
      now.setHours(0)
      now.setMinutes(0)
      now.setSeconds(0)
      now.setMilliseconds(0)
      const difValue = this.dayDifValue(selDate, now)

      let aheadLimit
      if (this.configData) {
        aheadLimit = this.configData.ahead_limit
      } else {
        aheadLimit = 0
      }
      let appointEndDate
      if (aheadLimit) {
        appointEndDate = utils.formatTimeYMDInterval(new Date(now.setDate(now.getDate() + aheadLimit - 1)), '-')
      } else {
        appointEndDate = appointStartDate
      }
      return {
        appointStartDate: appointStartDate,
        appointEndDate: appointEndDate,
        pre: difValue > 0,
        next: difValue < aheadLimit - 1
      }
    }
  }
}
</script>
<style scoped lang="scss">
.content_box {
  .top-bg {
    height: 6.25rem;
    position: absolute;
    display: flex;
    left: 0;
    right: 0;
    top: 0;
    z-index: -1;
    background-color: #74b0f9;
    /* background:linear-gradient(180deg,#74B0F9 0%,rgba(68,166,255,1) 30%,rgba(0,134,255,0) 100%); */
  }
  .full-title-parent {
    align-items: center;
    // margin-top: 1.5rem;
    /* margin-left: 48rpx; */
  }
  .appoint-date-wrap {
    box-sizing: border-box;
    padding: 0 1.5rem;
    margin-top: 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: white;
    font-size: 0.875rem;
    /* background-color: black; */
  }
  .full-date {
    width: 8.375rem;
    height: 2rem;
    line-height: 2rem;
    text-align: center;
    background: #ffffff;
    border-radius: 0.125rem;
    color: #74b0f9;
  }
  .building-info {
    box-sizing: border-box;
    margin-top: 0.5rem;
    padding: 0.9375rem 1.5rem;
    display: flex;
    align-items: center;
    background-color: white;
  }
  .building {
    /* width: 110px; */
    height: 1.5625rem;
    font-size: 1.125rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 1.5625rem;
  }
  .building-floor {
    /* width: 110px; */
    margin-left: 0.9375rem;
    height: 1.5625rem;
    font-size: 1.125rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 1.5625rem;
  }
  .building-room-type {
    /* width: 61px; */
    margin-left: 0.9375rem;
    display: flex;
    align-items: center;
    height: 1.25rem;
    padding: 0 0.4375rem;
    font-size: 0.6875rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    background: #74b0f9;
    border-radius: 0.125rem;
  }
  .selected-time-wrap {
    /* width: 375px; */
    display: flex;
    height: 2rem;
    justify-content: space-around;
    align-items: center;
    background: #f6faff;
    border-radius: 0.125rem;
    border: 0.0625rem solid #e0edfd;
  }

  .content-parent {
    position: absolute;
    left: 0.875rem;
    right: 0.875rem;
    top: 12rem;
    bottom: 4.5rem;
    background: #fff;
    /* background: red; */
    border-radius: 0.5rem 0.5rem 0 0;
  }
  /* .select-day{
  margin-right: 32rpx;
  display: flex;
  cursor: pointer;
} */
  .next-day {
    margin-left: 0.625rem;
  }
  /* .show-time-parent{
  display: flex;
  margin-top: 32rpx;
  margin-bottom: 40rpx;
  flex-direction: row;
  align-items: center;
} */
  .show-start-time {
    width: 6.875rem;
    height: 2.625rem;
    line-height: 2.625rem;
    text-align: center;
    margin-left: 1rem;
    margin-right: 0.6875rem;
    /* background: #fff; */
    /* border-radius: 8rpx;  */
    color: #333;
    /* font-size: 28rpx; */
    /* box-shadow: 0rpx 0rpx 10rpx 0rpx rgba(1, 1, 1, 0.1); */
  }
  .show-start-time.empty {
    color: #999;
  }
  .show-end-time {
    width: 6.875rem;
    height: 2.625rem;
    line-height: 2.625rem;
    text-align: center;
    margin-left: 0.6875rem;
    /* background: #fff; */
    /* border-radius: 8rpx;  */
    color: #333;
    font-size: 0.875rem;
    /* box-shadow: 0rpx 0rpx 10rpx 0rpx rgba(1, 1, 1, 0.1); */
  }
  .show-end-time.empty {
    color: #999;
  }
  .clear-selt-time {
    height: 2.625rem;
    line-height: 2.625rem;
    margin-left: 1.125rem;
    font-weight: bold;
  }
  .time-list-parent {
    position: absolute;
    /* top: 240rpx; */
    top: 0px;
    bottom: 1.5625rem;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: space-around;
    overflow-y: auto;
  }
  .time-list-item {
    position: relative;
    width: 7rem;
    height: 1.5rem;
    line-height: 1.5rem;
    text-align: center;
    margin-top: 0.625rem;
    font-size: 0.9375rem;
    font-weight: bold;
    color: #333;
  }
  .time-list-item.invalid {
    color: #d0d0d0;
  }
  .time-list-item.include {
    /* background: #E8F4FF; */
    background: #74b0f9;
    color: white;
  }
  .time-list-item.start {
    border-radius: 1.125rem 0 0 1.125rem;
    /* background: #E8F4FF; */
    background: #74b0f9;
    color: white;
  }
  .time-list-item.end {
    border-radius: 0 1.125rem 1.125rem 0;
    /* background: #E8F4FF; */
    background: #74b0f9;
    color: white;
  }
  .time-list-item.only {
    border-radius: 1.125rem;
    /* background: #E8F4FF; */
    background: #74b0f9;
    color: white;
  }
  .line-through {
    text-decoration: line-through;
  }
  /* .time-list-item-content{
  line-height: 1;
} */

  .bottom-shade {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 4.6875rem;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 46%,
      rgba(255, 255, 255, 1) 100%
    );
  }
  .appointment {
    position: absolute;
    bottom: 1rem;
    left: 0.9375rem;
    right: 0.9375rem;
    height: 3.125rem;
    line-height: 3.125rem;
    text-align: center;
    font-size: 1.25rem;
    color: #fff;
    border-radius: 0.125rem;
    /* background-color: #FF9D00; */
    background-color: #74b0f9;
  }
}

.orderUserBox{
  padding: 1rem;
  display: flex;
  flex-direction: column;
  .title{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: .625rem;
    color: #666;
    text-align: center;
  }
  .number{
    font-size: .875rem;
    color: #333;
    margin-top: 1.25rem;
    display: flex;
    align-items:center;
    justify-content: center;
   /deep/ .van-field{
    width: 7.5rem;
   }
  }
}
</style>
